export default function navSecondary() {
	return {
		restrict: 'C',
		link: function (scope, element, attrs) {
			const links = element[0].querySelectorAll('a');

			links.forEach(link => {
				link.addEventListener('click', () => {
					document.querySelector('html').classList.remove('droppin-in');

					const header = document.querySelector('.section--header');
					if (header) {
						header.classList.remove('dropped');
					}
				});
			});
		}
	};
}
